import Login from '@/views/Login/Login.vue';
import Signup from '@/views/Signup/Signup.vue';
import Home from '@/views/home/Home.vue';

import DetectorIndex from '@/views/detector/DetectorIndex/DetectorIndex.vue';
import TrainerIndex from '@/views/trainer/TrainerIndex/TrainerIndex.vue';
import ToppageIndex from '@/views/toppage/ToppageIndex/ToppageIndex.vue';
import HistoryIndex from '@/views/history/HistoryIndex/HistoryIndex.vue';
import ProfileIndex from '@/views/profile/ProfileIndex/ProfileIndex.vue';
import SettingIndex from '@/views/AdvanceSetting/SettingIndex.vue';
import Model from '@/views/Model/Model.vue';

const routes = [
	{
		path: '/',
		component: Login,
		name: 'main',
		meta: { namespace: 'auth' },
	},
	{
		path: '/login',
		component: Login,
		name: 'Login',
	},
	{
		path: '/signup',
		component: Signup,
	},
	{
		path: '/home',
		component: Home,
		name: 'Home',
		meta: { namespace: 'detector' },
	},
	{
		path: '/camera',
		component: DetectorIndex,
		meta: { namespace: 'detector' },
	},
	{
		path: '/trainer',
		component: TrainerIndex,
		meta: { namespace: 'trainer' },
	},
	{
		path: '/toppage',
		component: ToppageIndex,
		meta: { namespace: 'toppage' },
	},
	{
		path: '/history',
		component: HistoryIndex,
		meta: { namespace: 'history' },
	},
	{
		path: '/profile',
		component: ProfileIndex,
		meta: { namespace: 'profile' },
	},
	{
		path: '/setting',
		component: SettingIndex,
		meta: { namespace: 'setting' },
	},
	{
		path: '/model',
		component: Model,
		meta: { namespace: 'model' }
	}
];

export default routes;
